import React, { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { Container, Row, Col, Card, Button, Spinner } from 'react-bootstrap';
import apiService from '../../Common/Configurations/APIService';
import config from '../../Common/Configurations/APIConfig';
import './HolidayScreen.css'; 
import DefaultData from '../../CompanyData/DefaultData';
const PackageCard = ({ pkg }) => (
    <Card className="package-card h-100">
        <Card.Img variant="top" src={pkg.imageSrc || 'https://via.placeholder.com/400x200?text=Package'} alt={pkg.packageName} />
        <Card.Body className="d-flex flex-column">
            <Card.Title className="fw-bold mb-1">
                <Link to={`/holiday-details/${pkg.packageId}`} className="card-title-link">
                    {pkg.packageName}
                </Link>
            </Card.Title>
            <div className="icon-text mb-2 small">
                <i className="ri-map-pin-line me-1"></i>
                <span>{pkg.destinationsCover}</span>
            </div>
            <div className="mt-auto pt-3">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <div className="icon-text fw-medium">
                        <i className="ri-calendar-2-line me-1"></i>
                        <span>{pkg.duration}</span>
                    </div>
                    <span className="price-tag">{pkg.currency} {pkg.price}</span>
                </div>
                <div className="d-grid">
                    <Button as={Link} to={`/holiday-details/${pkg.packageId}`} variant="primary">View Details</Button>
                </div>
            </div>
        </Card.Body>
    </Card>
);

const HolidayResults = () => {
    const [searchParams] = useSearchParams();
    const [packages, setPackages] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const destination = searchParams.get('destination') || '';
    const traveltype = searchParams.get('traveltype') || '';
    const month = searchParams.get('month') || '';
    const companyId = DefaultData.DEFAULTCOMPANYID;

    useEffect(() => {
        const getPackages = async () => {
            setIsLoading(true);
            try {
               
                const query = new URLSearchParams({
                    searchText: destination,
                    traveltype: traveltype,
                    month: month,
                }).toString();

                const response = await apiService.getAll(`${config.GETPACKAGESBYSEARCH}/${companyId}?${query}`);
                setPackages(response.data);
            } catch (error) {
                console.error("Failed to fetch search results:", error);
            } finally {
                setIsLoading(false);
            }
        };

        getPackages();
    }, [destination, traveltype, month, companyId]);

    return (
        <div className="main-content">
            <div className="page-content">
                <Container className="my-1">

                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <h2 className="section-title mb-0">Search Results</h2>
                        <Button as={Link} to="/holidays" variant="outline-secondary">
                            <i className="ri-arrow-left-line me-2"></i>Back to Search
                        </Button>
                    </div>
                    <p className="text-center text-muted mb-5">
                        Showing packages {destination && `for "${destination}"`} {traveltype && `of traveltype "${traveltype}"`} {month && `in "${month}"`}
                    </p>


                    {isLoading ? (
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Searching for packages...</p>
                        </div>
                    ) : packages.length > 0 ? (
                        <Row xs={1} md={2} lg={3} className="g-4">
                            {packages.map(pkg => (
                                <Col key={pkg.packageId}>
                                    <PackageCard pkg={pkg} />
                                </Col>
                            ))}
                        </Row>
                    ) : (
                        <div className="text-center">
                            <h4>No Packages Found</h4>
                            <p>Try adjusting your search criteria.</p>
                            <Button as={Link} to="/holidays">Back to Holidays</Button>
                        </div>
                    )}
                </Container>
            </div>
        </div>
    );
};

export default HolidayResults;